var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.kind === "material"
        ? _c(
            "a-input-group",
            {
              staticStyle: { width: "100%", top: "0px", display: "flex" },
              attrs: { compact: "" },
            },
            [
              _c(
                "a-select",
                {
                  staticStyle: { flex: "1", "min-width": "0" },
                  attrs: {
                    placeholder: "输入条码或名称",
                    dropdownMatchSelectWidth: false,
                    showSearch: "",
                    showArrow: false,
                    optionFilterProp: "children",
                    notFoundContent: "需在商品管理先新增才能使用",
                  },
                  on: { search: _vm.handleSearch, change: _vm.handleChange },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleEnter.apply(null, arguments)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "dropdownRender",
                        fn: function (menu) {
                          return _c(
                            "div",
                            {},
                            [
                              _c("v-nodes", { attrs: { vnodes: menu } }),
                              _vm.materialData.length === 20
                                ? _c("a-divider", {
                                    staticStyle: { margin: "4px 0" },
                                  })
                                : _vm._e(),
                              _vm.materialData.length === 20
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        padding: "4px 8px",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        mousedown: (e) => e.preventDefault(),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "此处最多显示20条，如需更多请点击放大镜查询"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                    ],
                    null,
                    false,
                    1561778350
                  ),
                  model: {
                    value: _vm.names,
                    callback: function ($$v) {
                      _vm.names = $$v
                    },
                    expression: "names",
                  },
                },
                _vm._l(_vm.materialData, function (item) {
                  return _c("a-select-option", { key: item.barCode }, [
                    _vm._v(
                      "\n        " + _vm._s(item.materialStr) + "\n      "
                    ),
                  ])
                }),
                1
              ),
              _c("a-button", {
                attrs: { icon: "search" },
                on: { click: _vm.onSearch },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.kind === "batch" || _vm.kind === "sn" || _vm.kind === "snAdd"
        ? _c("a-input-search", {
            attrs: { placeholder: "请点开弹窗", readOnly: "" },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.names,
              callback: function ($$v) {
                _vm.names = $$v
              },
              expression: "names",
            },
          })
        : _vm._e(),
      _vm.kind === "material"
        ? _c("j-select-material-modal", {
            ref: "selectModal",
            attrs: {
              rows: _vm.rows,
              multi: _vm.multi,
              "bar-code": _vm.value,
              "enable-asset": _vm.enableAsset,
            },
            on: { ok: _vm.selectOK, initComp: _vm.initComp },
          })
        : _vm._e(),
      _vm.kind === "batch"
        ? _c("j-select-batch-modal", {
            ref: "selectModal",
            attrs: { rows: _vm.rows, multi: _vm.multi, "bar-code": _vm.value },
            on: { ok: _vm.selectOK, initComp: _vm.initComp },
          })
        : _vm._e(),
      _vm.kind === "sn"
        ? _c("j-select-sn-modal", {
            ref: "selectModal",
            attrs: { rows: _vm.rows, multi: _vm.multi, "bar-code": _vm.value },
            on: { ok: _vm.selectOK, initComp: _vm.initComp },
          })
        : _vm._e(),
      _vm.kind === "snAdd"
        ? _c("j-select-sn-add-modal", {
            ref: "selectModal",
            attrs: { rows: _vm.rows, multi: _vm.multi, "bar-code": _vm.value },
            on: { ok: _vm.selectOK, initComp: _vm.initComp },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }